<!-- Los ratios de Syntage como referencia (D-42): debajo de los de Rendafin, o solos si la calculadora no tiene foto. -->
<ng-template #syntageBlock>
  <div class="alg-block" data-test="syntage-ratios-block">
    <div class="alg-divider"><span>Ratios según Syntage</span></div>
    <p class="syntage-hint">Calculados por Syntage con su propia definición; se muestran como referencia y no entran a la calculadora.</p>
    <app-syntage-ratios [ratios]="syntageRatios"></app-syntage-ratios>
  </div>
</ng-template>

<section class="snapshot-tab" aria-label="Ratios">
  <ng-container *ngIf="envelopeState; else withResult">
    <app-snapshot-state [state]="envelopeState" [savedRatios]="!!syntageRatios" (retry)="retry()"></app-snapshot-state>
    <article class="alg-card fallback-card" *ngIf="envelopeState !== 'loading' && syntageRatios">
      <div class="alg-card__body"><ng-container *ngTemplateOutlet="syntageBlock"></ng-container></div>
    </article>
  </ng-container>

  <ng-template #withResult>
    <article class="alg-card">
      <header class="alg-card__header">
        <span class="alg-card__icon"><i class="fa-solid fa-scale-balanced" aria-hidden="true"></i></span>
        <div class="alg-card__titles">
          <h2>Ratios por ejercicio</h2>
          <p>
            Declaración anual del SAT y flujo CFDI de la foto ·
            <span class="star-legend"><i class="fa-solid fa-star" aria-hidden="true"></i> los usa la calculadora</span>
          </p>
        </div>
        <span class="alg-pill is-info" *ngIf="effectiveYear" data-test="ratios-effective">La calculadora usa {{ effectiveYear }}</span>
      </header>

      <p class="alg-notice is-neutral" *ngIf="!hasYears" data-test="ratios-no-statements">
        <i class="fa-solid fa-circle-minus" aria-hidden="true"></i>
        <span>La foto no trae declaración anual con estados financieros: no hay ratios por ejercicio.</span>
      </p>

      <div class="alg-card__body">
        <div class="ratio-groups">
          <ng-container *ngFor="let group of ratios?.groups ?? []; trackBy: trackByIndex">
            <div class="alg-block" *ngIf="hasYears || hasTrailing(group)" [attr.data-test]="'rendafin-group-' + group.key">
              <h3 class="group-title">{{ group.label }}</h3>
              <div class="alg-table-wrap">
                <table class="alg-table rendafin-ratios">
                  <caption class="p-hidden-accessible">
                    {{
                      group.label + ' por ejercicio'
                    }}
                  </caption>
                  <thead>
                    <tr>
                      <th scope="col" class="ratio-name-col">Ratio</th>
                      <th
                        scope="col"
                        class="is-num"
                        *ngFor="let year of ratios!.years; trackBy: trackByIndex"
                        [class.is-effective]="year === effectiveYear"
                      >
                        {{ year }}
                      </th>
                      <th scope="col" class="is-num is-effective" *ngIf="hasTrailing(group)" data-test="trailing-header">
                        Últimos 12 meses
                        <span class="alg-table__sub" *ngIf="ratios?.trailingWindow as window"
                          >{{ month(window.from) }} a {{ month(window.to) }}</span
                        >
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let row of group.ratios; trackBy: trackByIndex" [attr.data-test]="'ratio-' + row.key">
                      <th scope="row" class="ratio-name" [pTooltip]="row.formula" tooltipPosition="top">
                        <span
                          >{{ row.label
                          }}<i
                            *ngIf="row.usedByScorecard"
                            class="fa-solid fa-star used-star"
                            role="img"
                            aria-label="lo usa la calculadora"
                            data-test="used-by-scorecard"
                          ></i
                        ></span>
                        <span class="alg-table__sub formula" data-test="ratio-formula">{{ row.formula }}</span>
                        <span class="alg-table__sub" *ngIf="row.flags.length" data-test="ratio-flags">{{ flagsText(row.flags) }}</span>
                      </th>
                      <td
                        class="is-num"
                        *ngFor="let year of ratios!.years; trackBy: trackByIndex"
                        [class.is-effective]="year === effectiveYear"
                        data-test="ratio-value"
                      >
                        {{ value(row, row.values[year]) }}
                      </td>
                      <td class="is-num is-effective is-strong" *ngIf="hasTrailing(group)" data-test="ratio-trailing">
                        {{ row.trailing12m === undefined ? '' : value(row, row.trailing12m) }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </ng-container>
        </div>

        <ng-container *ngTemplateOutlet="syntageBlock"></ng-container>
      </div>
    </article>
  </ng-template>
</section>
